import { IRole, IUser } from '../../interfaces/user';
import { SET_ROLES, SET_USER_DETAILS } from '../types';

// Define the initial state
export interface MeateryState {
    roles: IRole[];
    userDetails?: IUser;
}

const initialState: MeateryState = {
    roles: [],
    userDetails: undefined

};

// Reducer function
const reducer = (state = initialState, action: any): MeateryState => {
    switch (action.type) {
        case SET_ROLES:
            return {
                ...state,
                roles: action.payload
            };
        case SET_USER_DETAILS:
            return {
                ...state,
                userDetails: action.payload
            };

        default:
            return state;
    }
};

export default reducer;
